/**
 * @generated SignedSource<<aa33b25b1d4fe12af10029338ca661b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type insuranceServiceCreateMutation$variables = {
  email: string;
  name: string;
  phoneNumbers?: ReadonlyArray<string> | null | undefined;
  userId: string;
};
export type insuranceServiceCreateMutation$data = {
  readonly insert_insurance_agent_one: {
    readonly id: string;
  } | null | undefined;
};
export type insuranceServiceCreateMutation = {
  response: insuranceServiceCreateMutation$data;
  variables: insuranceServiceCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "phoneNumbers"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "email",
            "variableName": "email"
          },
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "userId"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "phoneNumbers",
            "variableName": "phoneNumbers"
          }
        ],
        "kind": "ObjectValue",
        "name": "object"
      }
    ],
    "concreteType": "insurance_agent",
    "kind": "LinkedField",
    "name": "insert_insurance_agent_one",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "insuranceServiceCreateMutation",
    "selections": (v4/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "insuranceServiceCreateMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "b6dddacef7a7b217fbed02eaf09715f0",
    "id": null,
    "metadata": {},
    "name": "insuranceServiceCreateMutation",
    "operationKind": "mutation",
    "text": "mutation insuranceServiceCreateMutation(\n  $userId: String!\n  $email: String!\n  $name: String!\n  $phoneNumbers: [String!]\n) {\n  insert_insurance_agent_one(object: {id: $userId, email: $email, name: $name, phoneNumbers: $phoneNumbers}) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c2c99368563fde835b069d33e90f094d";

export default node;
